import BannerPage from 'pages/Creatives/Banners/index';

const Page = () => {
  return <BannerPage isAdmin={true} />;
};

export default Page;
